import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController ,Content} from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { SelectCountryPage } from '../select-country/select-country';
import { SelectZonesPage } from '../select-zones/select-zones';
import { BillingAddressPage } from '../billing-address/billing-address';
import { ShippingMethodPage } from '../shipping-method/shipping-method';
import { ThankYouPage } from '../thank-you/thank-you';
import { FinancePage } from '../finance-offer/finance-offer';

@Component({
  selector: 'page-shipping-address',
  templateUrl: 'shipping-address.html',
})


export class ShippingAddressPage {
  @ViewChild(Content) contentArea: Content;
  errorMessage = '';
addresses = new Array;
foundAddress: boolean = false;
postcode_search = '';
goHighLevelLeads = [];
financeOptions = false;
  orderDetail = {};//include shipping address, billing address,  shipping methods.

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public config: ConfigProvider,
    public http: Http,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public loading: LoadingProvider, ) {
      // Appsee.startScreen("Address");


  }

  ionViewDidLoad() {
    this.postcode_search = !(this.shared.orderDetails.delivery_postcode == undefined) ? this.shared.orderDetails.delivery_postcode : '';
    //this.getLeads();
    if(this.shared.customerData.isApproved == '1'){
      this.financeOptions = true;
    }
    else{
      this.financeOptions = false;
    }

  }



setCommPrefs = function(prefs){
  console.log("Set Prefs:",prefs)

}
financeChange =function($event){

}

addOrder = function (nonce) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //let regExp = /^[0-9]{11}$/;
  let regExp = /((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}/;
  this.errorMessage = '';

  if(this.shared.orderDetails.contactPref == "both")
  {

  if(!re.test(this.shared.orderDetails.customers_email_address)) {
    // Invalid Email
      this.contentArea.scrollToTop(300);
      this.errorMessage = "You need to enter a valid Email and Mobile #";
      return;
  }
  if(!regExp.test(this.shared.orderDetails.customers_telephone)) {
    // Invalid Email
      this.contentArea.scrollToTop(300);
      this.errorMessage = "You need to enter a valid Email and Mobile #";
      return;
  }



  }
  else if(this.shared.orderDetails.contactPref == "email")
  {

    if(!re.test(this.shared.orderDetails.customers_email_address)) {
      // Invalid Email
        this.contentArea.scrollToTop(300);
        this.errorMessage = "You need to enter a valid Email address";
        return;
    }
    //if(!regExp.test(this.shared.orderDetails.customers_telephone)) {
      // Invalid Email
      //  this.contentArea.scrollToTop(300);
    //  this.errorMessage = "You need to enter a valid Mobile #";
    //  return;
    //}

  }
  else if(this.shared.orderDetails.contactPref == "sms")
  {
    if(!regExp.test(this.shared.orderDetails.customers_telephone)) {
      // Invalid Email
        this.contentArea.scrollToTop(300);
      this.errorMessage = "You need to enter a valid Mobile #";
      return;
    }

    if(this.shared.customerData.isApproved == '1')
    {
      if(!re.test(this.shared.orderDetails.customers_email_address)) {
        // Invalid Email
          this.contentArea.scrollToTop(300);
          this.errorMessage = "You need to enter a valid Email and Mobile #";
          return;
      }
    }


  }

    // All inputs valid lets proceed
		console.log("Shared Data:",this.shared);
    console.log("Quote Type:",this.shared.orderDetails.previeworder.quote_type);
    this.loading.show();
    this.orderDetail.customers_id = this.shared.customerData.customers_id;
    this.orderDetail.customers_name = this.shared.orderDetails.delivery_firstname + " " + this.shared.orderDetails.delivery_lastname;
    this.orderDetail.delivery_name = this.shared.orderDetails.delivery_firstname + " " + this.shared.orderDetails.delivery_lastname;
    this.orderDetail.first_name = this.shared.orderDetails.delivery_firstname ;
    this.orderDetail.last_name = this.shared.orderDetails.delivery_lastname;
    this.orderDetail.customers_email_address = this.shared.orderDetails.customers_email_address;
    if(this.shared.orderDetails.contactPref == "sms")
    {
      //this.orderDetail.customers_email_address = "dummy@dummy.com"
    }

    this.orderDetail.customers_telephone = this.shared.orderDetails.customers_telephone;
    if(this.shared.orderDetails.contactPref == "email")
    {
      //this.orderDetail.customers_telephone = "11111111"
    }
    if(this.financeOptions == false)
    {
    //this.orderDetail.quote_type = this.shared.orderDetails.previeworder.quote_type;
    this.orderDetail.quote_type = 'quote';
    }
    else{
      this.orderDetail.quote_type = 'finance';
    }

    this.orderDetail.delivery_suburb = this.shared.orderDetails.delivery_state
    this.orderDetail.customers_suburb = this.shared.orderDetails.customers_state;
    this.orderDetail.delivery_email_address = this.shared.orderDetails.delivery_email_address;
    this.orderDetail.customers_address_format_id = '1';
    this.orderDetail.delivery_address_format_id = '1';
    this.orderDetail.products = this.products;
    this.orderDetail.is_coupon_applied = this.couponApplied;
    this.orderDetail.coupons = this.couponArray;
    this.orderDetail.coupon_amount = this.discount;
    this.orderDetail.totalPrice = this.totalAmountWithDisocunt;
    this.orderDetail.electrical_work = this.shared.orderDetails.previeworder.electrical_work;
    this.orderDetail.additional_parts = this.shared.orderDetails.previeworder.additional_parts;
    this.orderDetail.additional_labor = this.shared.orderDetails.previeworder.additional_labor;
    this.orderDetail.customer_deposit = this.shared.orderDetails.previeworder.customer_deposit;

		this.orderDetail.delivery_street_address = this.shared.orderDetails.delivery_street_address;
		this.orderDetail.delivery_city = this.shared.orderDetails.delivery_city;
		this.orderDetail.delivery_postcode = this.shared.orderDetails.delivery_postcode;
		this.orderDetail.delivery_state = this.shared.orderDetails.delivery_state;
		this.orderDetail.totalPrice = this.shared.orderDetails.previeworder.totalPrice;
		this.orderDetail.shipping_method = this.shared.orderDetails.previeworder.shipping_method;
		this.orderDetail.products = this.shared.orderDetails.previeworder.products;
    this.orderDetail.contactPref =this.shared.orderDetails.contactPref;

    this.orderDetail.tax_zone_id = this.shared.orderDetails.tax_zone_id;
    this.orderDetail.delivery_zone =this.shared.orderDetails.delivery_zone;



    this.orderDetail.nonce = nonce;
    var data = this.orderDetail;

		console.log("Data to Post:",JSON.stringify(data));
    this.http.post(this.config.url + 'createQuote', data).map(res => res.json()).subscribe(data => {
        this.loading.hide();
      if (data.success == 1) {

				console.log("Quote Response:",JSON.stringify(data));
        this.shared.emptyCart();
        this.products = [];


        if(this.orderDetail.payment_method == "cash_on_delivery")
        {
          this.shared.orderDetails = {};
    this.navCtrl.setRoot(FinancePage,
			{orderID: data.orderid,
				fin1:data.fin1,
				offer1APR:data.offer1APR,
				offer1Term:data.offer1Term,
				offer1bullet1:data.offer1bullet1,
				offer1bullet2:data.offer1bullet2,
				offer1bullet3:data.offer1bullet3,
				fin2:data.fin2,
				offer2APR:data.offer2APR,
				offer2Term:data.offer2Term,
				offer2bullet1:data.offer2bullet1,
				offer2bullet2:data.offer2bullet2,
				offer2bullet3:data.offer2bullet3,
				fin3:data.fin3,
				offer3APR:data.offer3APR,
				offer3Term:data.offer3Term,
				offer3bullet1:data.offer3bullet1,
				offer3bullet2:data.offer3bullet2,
				offer3bullet3:data.offer3bullet3,
				totalfinanced:data.totalfinance});

        }
        else{

          this.shared.orderDetails = {};
          this.navCtrl.setRoot(ThankYouPage);
        }
      }
      if (data.success == 0) { this.alert.show(data.message); }
    }, err => {
      console.log("Error:",err);
      this.translate.get("Server Error").subscribe((res) => {
        this.alert.show(res + " " + err.status);
      });

    });
  };



  getAddress() {
    this.foundAddress = false;
    this.loading.show();
    console.log("Find Address:",this.postcode_search);
    var data: { [k: string]: any } = {};

    if(this.postcode_search == 'Test')
    {
    this.addresses = JSON.parse('[{"addressline1": "18 Test Street","summaryline": "18 Test Street, A Town, London, L16 6BS","number": "18","premise": "18","street": "Test Street","posttown": "A Town","county": "London","postcode": "L16 6BS"}]');
    console.log("Addresses:",data.addresses);
    this.loading.hide();
    this.contentArea.scrollToBottom(300);


    }
    else{
    data.postcode= this.postcode_search;

    this.http.post(this.config.url + 'getAddress', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      if (data.success == 1) {
        this.addresses = data.addresses;
      this.contentArea.scrollToBottom(300);



        }
      });
    }

    }
    setAddress(data){
      this.foundAddress = true;
      this.addresses = [];
      this.postcode_search = '';
      //console.log("Got Address:",data);
      this.shared.orderDetails.delivery_street_address = data.premise + ',' + data.street;
      this.shared.orderDetails.tax_zone_id = data.premise ;
      this.shared.orderDetails.delivery_zone = data.street;
      this.shared.orderDetails.delivery_city = data.posttown;
      this.shared.orderDetails.delivery_postcode = data.postcode;
      this.shared.orderDetails.delivery_state = data.county;

    }

  selectCountryPage() {
    let modal = this.modalCtrl.create(SelectCountryPage, { page: 'shipping' });
    modal.present();
  }
  selectZonePage() {
    let modal = this.modalCtrl.create(SelectZonesPage, { page: 'shipping', id: this.shared.orderDetails.delivery_country_id });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/shipping-address/shipping-address.ts